// src/pages/Profile.js
import React, { useEffect, useState } from "react";
import api from "../services/api";
import Swal from "sweetalert2";
import { UserIcon } from "lucide-react";

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [uploading, setUploading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [credit, setCredit] = useState(null);
  const [topupAmount, setTopupAmount] = useState(0);

  const token = localStorage.getItem("token");

  // const fileInputRef = useRef(null);

  useEffect(() => {
    fetchProfile();
    fetchCredit();
    loadDuitkuScript();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchProfile = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/users-profile`, {
        headers: { Authorization: token },
      });
      if (res.data.status === 0) {
        setUserData(res.data.data);
      } else {
        Swal.fire("Error", "Gagal mengambil data user.", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Terjadi kesalahan saat memuat data.", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchCredit = async () => {
    try {
      const res = await api.get(`/users-credit`, {
        headers: { Authorization: token },
      });
      setCredit(res.data.balance);
    } catch (err) {
      Swal.fire("Error", "Gagal mengambil saldo.", "error");
    }
  };

  const loadDuitkuScript = () => {
    if (!document.getElementById("duitku-script")) {
      const script = document.createElement("script");
      script.id = "duitku-script";
      script.src = "https://app-sandbox.duitku.com/lib/js/duitku.js";
      script.async = true;
      document.body.appendChild(script);
    }
  };

  // const handleImageUpload = async (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   const formData = new FormData();
  //   formData.append("profile_image", file);

  //   setUploading(true);
  //   try {
  //     const res = await api.put(`/profile/image`, formData, {
  //       headers: { Authorization: token },
  //     });

  //     if (res.data.status === 0) {
  //       const newImage = res.data.data.profile_image.replace(/\\/g, "/");
  //       setUserData((prev) => ({ ...prev, profile_picture: newImage }));

  //       const currentUser = JSON.parse(localStorage.getItem("user"));
  //       localStorage.setItem(
  //         "user",
  //         JSON.stringify({ ...currentUser, profile_picture: newImage })
  //       );

  //       Swal.fire("Berhasil", "Foto profil berhasil diupdate!", "success");
  //     } else {
  //       Swal.fire("Error", "Gagal mengupdate gambar.", "error");
  //     }
  //   } catch (err) {
  //     Swal.fire("Error", "Terjadi kesalahan saat upload gambar.", "error");
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  const handleTopup = async () => {
    if (!topupAmount || topupAmount <= 0) {
      Swal.fire("Error", "Masukkan jumlah topup yang valid.", "error");
      return;
    }

    setProcessing(true);
    try {
      const res = await api.post(
        `/topup`,
        {
          amount: parseInt(topupAmount),
          email: userData.email,
          phoneNumber: userData.whatsapp,
          productDetail: `Top Up Saldo ${topupAmount}`,
        },
        {
          headers: { Authorization: token },
        }
      );

      if (res.data.status === 0) {
        const reference = res.data.invoice.reference;
        const paymentUrl = res.data.invoice.paymentUrl;

        setTimeout(() => {
          if (window.checkout) {
            window.checkout.process(reference);
          } else {
            window.location.href = paymentUrl;
          }
          setProcessing(false);
        }, 1000);
      } else {
        Swal.fire("Error", "Gagal membuat invoice.", "error");
        setProcessing(false);
      }
    } catch (err) {
      Swal.fire(
        "Error",
        err.response?.data?.error || "Terjadi kesalahan.",
        "error"
      );
      setProcessing(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <UserIcon /> Profile
        </h1>
      </div>

      <div className="p-6 max-w-xl mx-auto bg-gray-100 dark:bg-gray-800 shadow rounded-lg">
        <div className="flex items-center gap-4">
          <img
            src={`http://localhost:5010/${userData.profile_picture}`}
            alt="Profile"
            className="w-20 h-20 rounded-full object-cover border"
          />

          <div>
            <h2 className="text-xl font-bold">
              {userData.first_name} {userData.last_name}
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {userData.group_name}
            </p>
          </div>
        </div>

        {/* <div className="mt-4">
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleImageUpload}
            className="hidden"
          />
          <button
            onClick={() => fileInputRef.current.click()}
            className="bg-blue-400 hover:bg-blue-700 text-white px-4 py-2 rounded"
          >
            Ubah Foto Profil
          </button>
          {uploading && (
            <p className="text-sm text-gray-500 mt-2">Mengunggah gambar...</p>
          )}
        </div> */}

        <div className="mt-6 space-y-2 text-gray-700 dark:text-gray-200">
          <p>
            <strong>Email:</strong> {userData.email}
          </p>
          <p>
            <strong>WhatsApp:</strong> {userData.whatsapp}
          </p>
          <p>
            <strong>Telepon:</strong> {userData.telp}
          </p>
          <p>
            <strong>Status:</strong>{" "}
            <span
              className={`inline-block px-2 py-1 rounded text-white text-sm ${
                userData.status === "active" ? "bg-green-400" : "bg-red-400"
              }`}
            >
              {userData.status}
            </span>
          </p>
          <p>
            <strong>Referral-Code Anda :</strong> {userData.referral_code}
          </p>
          <p>
            <strong>Saldo Anda:</strong> Rp{" "}
            {credit ? parseInt(credit).toLocaleString() : "-"}
          </p>
        </div>

        <div className="mt-6">
          <label className="block mb-2 font-semibold">Topup Saldo</label>
          <input
            type="number"
            value={topupAmount}
            onChange={(e) => setTopupAmount(e.target.value)}
            placeholder="Masukkan jumlah topup"
            className="w-full border border-gray-300 rounded px-4 py-2 mb-4 text-black"
          />
          <button
            onClick={handleTopup}
            className="bg-green-400 hover:bg-green-700 text-white px-4 py-2 rounded"
            disabled={processing}
          >
            {processing ? "Memproses..." : "Top-Up"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
